import { useEffect } from 'react';
import mqtt, { MqttClient } from 'mqtt';
import { MQTT_URL, MQTT_BROKER_URL, MQTT_USERNAME, MQTT_PASSWORD } from './config';

// small React hook to subscribe to a single topic and invoke a callback when
// messages arrive. the broker URL is taken from config; if the environment
// provides both MQTT_URL (ws) and MQTT_BROKER_URL (tcp) the latter is used.
// the callback is guaranteed to be called on the latest values thanks to
// React hook semantics.

export default function useMqtt(topic: string, handler: (msg: any) => void) {
  useEffect(() => {
    const url = MQTT_BROKER_URL || MQTT_URL;
    if (!url) return;

    const opts: mqtt.IClientOptions = {};
    if (MQTT_USERNAME) opts.username = MQTT_USERNAME;
    if (MQTT_PASSWORD) opts.password = MQTT_PASSWORD;

    const client: MqttClient = mqtt.connect(url, opts);
    client.on('error', (e) => {
      console.warn('mqtt client error', e);
    });

    client.subscribe(topic, (err) => {
      if (err) console.warn('mqtt subscribe failed', err);
    });

    client.on('message', (t, payload) => {
      if (t === topic) {
        try {
          handler(JSON.parse(payload.toString()));
        } catch (e) {
          // ignore parse errors
        }
      }
    });

    return () => {
      client.end();
    };
  }, [topic, handler]);
}
